import React from "react";
import Image from "../../../elements/Image";
import TakeActionImage from "../../../../assets/image/image-take-action-02.webp";
import Bow from "../../../../assets/image/bow.svg";
import TakeActionForm from "./TakeActionForm";

const SectionTakeAction = ({ data }) => {
  return (
    <>
      <section className="relative flex w-full pt-10 pb-16 xls:py-24 bg-white">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="flex lg:grid lg:grid-cols-2 gap-10 bg-white pb-6 md:py-6 px-6 rounded-3xl shadow-[0px_2px_20px_rgba(0,0,0,0.1)] max-w-7xl mx-auto flex-col-reverse">
            <div className="flex flex-shrink-0 w-full max-w-xl text-white space-y-10">
              <div className="overflow-hidden relative rounded-2xl z-0 bg-chestnut-rose mix-blend-multiply w-full min-h-[500px]">
                <div className="absolute top-0 left-0 w-full h-full z-10 flex flex-col items-center justify-center bg-green-500/10">
                  <div className="relative text-5xl lg:text-6xl font-bold max-w-60 !leading-normal">
                    <span className="absolute -top-10 -left-10">
                      <Image
                        src={Bow}
                        alt={""}
                        effect="blur"
                        classes="object-cover"
                      />
                    </span>
                    Inspiring Tomorrow With Today’s Action.
                  </div>
                </div>
                <Image
                  src={data?.details?.takeAction?.sectionImage?.url}
                  alt={""}
                  effect="blur"
                  classes="object-cover mix-blend-multiply saturate-[0.5] !opacity-50"
                />
              </div>
            </div>
            <div className="flex flex-col flex-shrink-0 w-full max-w-xl">
              <TakeActionForm data={data} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionTakeAction;
